import React, { useMemo } from 'react'
import clsx from 'clsx'

import { SidebarLink } from 'ui/Layout/Sidebar/SidebarLink'
import type { CategorySchema } from 'openapi'
import { createCategoriesTree } from 'features/categories/utils'
import type { CategoryWithChildren } from 'features/categories/interfaces'

type Props = {
  categories: CategorySchema[]
  className?: string
  topList?: boolean
  useIcons?: boolean
}

export const SidebarCategoriesList = React.memo((props: Props) => {
  const { categories, className } = props

  const categoriesTree = useMemo(() => createCategoriesTree(categories, false), [categories])

  return (
    <ul className={clsx('space-y-0', className)}>
      {categoriesTree.map((category, _i) => (
        <SidebarListItem key={category.id} category={category} />
      ))}
    </ul>
  )
})

function SidebarListItem({ category, level = 0 }: { category: CategoryWithChildren; level?: number }) {
  const paddingClass = {
    0: 'pl-2',
    1: 'pl-4',
    2: 'pl-6',
    3: 'pl-8',
    4: 'pl-10',
  }[level]

  const link = category.children.length === 0 ? `/category/${category.id}/` : undefined
  return (
    <>
      <li>
        <SidebarLink link={link} className={paddingClass}>
          <span>
            {category.name}
            {category?.softwareCount > 0 && (
              <span className="pl-1 text-gray-400 font-light text-xs">{category?.softwareCount}</span>
            )}
          </span>
        </SidebarLink>
      </li>
      {category.children.map((child) => (
        <SidebarListItem key={child.id} category={child} level={level + 1} />
      ))}
    </>
  )
}
